
import * as React from 'react';
import { IconAmenitiesRooms } from '../components/icons/IconAmenitiesRooms';
import { IconAwardsCertificates } from '../components/icons/IconAwardsCertificates';
import { IconBeach } from '../components/icons/IconBeach';
import { IconBusinessServices } from '../components/icons/IconBusinessServices';
import { IconClothesCleaningServices } from '../components/icons/IconClothesCleaningServices';
import { IconEntertainment } from '../components/icons/IconEntertainment';
import { IconGeneralServices } from '../components/icons/IconGeneralServices';
import { IconHealthBeauty } from '../components/icons/IconHealthBeauty';
import { IconInternet } from '../components/icons/IconInternet';
import { IconNutrition } from '../components/icons/IconNutrition';
import { IconParking } from '../components/icons/IconParking';
import { IconRecreationWater } from '../components/icons/iconRecreationWater';
import { IconServicesChildren } from '../components/icons/IconServicesChildren';
import { IconSmoking } from '../components/icons/IconSmoking';
import { IconSpecialRooms } from '../components/icons/IconSpecialRooms';
import { IconSport } from '../components/icons/IconSport';
import { IconswimmingPool } from '../components/icons/IconswimmingPool';
import { IconTransport } from '../components/icons/IconTransport';


/** @format */
interface IconsFacility {
    id: number;
    icon: React.ReactNode;
    name: string;
}

export const iconsFacility: IconsFacility[] = [
    {
        id: 1,
        name: 'Интернет',
        icon: <IconInternet />,
    },
    {
        id: 2,
        name: 'Общие услуги',
        icon: <IconGeneralServices />,
    },
    {
        id: 3,
        name: 'Парковка',
        icon: <IconParking />,
    },
    {
        id: 5,
        name: 'Спорт',
        icon: <IconSport />,
    },
    // нет иконки
    {
        id: 6111,
        name: 'Пляжная линия',
        icon: <IconBeach />,
    },
    {
        id: 7,
        name: 'Бизнес-услуги',
        icon: <IconBusinessServices />,
    },
    {
        id: 8,
        name: 'Удобства в номера',
        icon: <IconAmenitiesRooms />,
    },
    {
        id: 9,
        name: 'Специальные номера',
        icon: <IconSpecialRooms />,
    },
    {
        id: 10,
        name: 'Питание',
        icon: <IconNutrition />,
    },
    {
        id: 11,
        name: 'Транспорт',
        icon: <IconTransport />,
    },
    {
        id: 12,
        name: 'Услуги по чистке одежды',
        icon: <IconClothesCleaningServices />,
    },
    {
        id: 13,
        name: 'Развлечения',
        icon: <IconEntertainment />,
    },
    {
        id: 14,
        name: 'Отдых на воде',
        icon: <IconRecreationWater />,
    },
    {
        id: 15,
        name: 'Здоровье и красота',
        icon: <IconHealthBeauty />,
    },
    {
        id: 16,
        name: 'Курение',
        icon: <IconSmoking />,
    },
    {
        id: 18,
        name: 'Услуги для детей',
        icon: <IconServicesChildren />,
    },
    {
        id: 19,
        name: 'Пляж',
        icon: <IconBeach />,
    },
    {
        id: 22,
        name: 'Бассейн',
        icon: <IconswimmingPool />,
    },
    {
        id: 23,
        name: 'Премии и сертификаты',
        icon: <IconAwardsCertificates />,
    },
];
